import { LanguagesEnum } from '../../models/global-settings/global-settings.model';

export const SUPPORTED_LANGS = [
    { id: 'en', label: 'English', dir: 'ltr' as const },
    { id: 'en-au', label: 'English (Australia)', dir: 'ltr' as const },
    { id: 'en-us', label: 'English (US)', dir: 'ltr' as const },
    { id: 'zh', label: '中文', dir: 'ltr' as const },
    { id: 'da', label: 'Dansk', dir: 'ltr' as const },
    { id: 'fr', label: 'Français', dir: 'ltr' as const },
    { id: 'de', label: 'Deutsch', dir: 'ltr' as const },
    { id: 'it', label: 'Italiano', dir: 'ltr' as const },
    { id: 'pt', label: 'Português', dir: 'ltr' as const },
    { id: 'es', label: 'Español', dir: 'ltr' as const },
    { id: 'zh-tw', label: '繁體中文', dir: 'ltr' as const },
];

export const DEFAULT_LANG = 'en';

export type LangId = (typeof SUPPORTED_LANGS)[number]['id'];

/**
 * Maps the `LanguagesEnum` saved in Global Settings to a transloco lang id.
 * Each enum value has its own translation file under `public/i18n/<id>.json`.
 */
export function mapLanguageEnumToLangId(lang: LanguagesEnum | null | undefined): LangId {
    switch (lang) {
        case LanguagesEnum.English:
            return 'en';
        case LanguagesEnum.EnglishAustralia:
            return 'en-au';
        case LanguagesEnum.EnglishUS:
            return 'en-us';
        case LanguagesEnum.Chinese:
            return 'zh';
        case LanguagesEnum.Danish:
            return 'da';
        case LanguagesEnum.French:
            return 'fr';
        case LanguagesEnum.German:
            return 'de';
        case LanguagesEnum.Italian:
            return 'it';
        case LanguagesEnum.Portuguese:
            return 'pt';
        case LanguagesEnum.Spanish:
            return 'es';
        case LanguagesEnum.ChineseTraditional:
            return 'zh-tw';
        default:
            return DEFAULT_LANG;
    }
}
